module.exports = __webpack_public_path__ + "img/9788957981702.517b38c4.jpg";